import { SharedInputEdit } from '../../components/SharedInputEdit';

export function WorkforceInput(): JSX.Element {
    return (
        <div className="workforce">
            <SharedInputEdit inputName='technologist'/>
            <SharedInputEdit inputName='technologist_overtime_percent'/>
            <SharedInputEdit inputName='technologist_wages_per_hour'/>

            <SharedInputEdit inputName='radiologist'/>
            <SharedInputEdit inputName='radiologist_overtime_percent'/>
            <SharedInputEdit inputName='radiologist_wages_per_hour'/>
        </div>
    );
}
